import ArrowCircleDownSharpIcon from '@mui/icons-material/ArrowCircleDownSharp'
import ArrowCircleUpSharpIcon from '@mui/icons-material/ArrowCircleUpSharp'
import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  PaginationState,
  SortingState,
  useReactTable,
} from '@tanstack/react-table'
import React from 'react'

type TypeScriptTableProps = {
  data: any
  columns: any
  isLoading?: boolean
}

const StyledTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  '& th, & td': {
    padding: theme.spacing(1),
    textAlign: 'left',
  },
  '& tbody td': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& th': {
    backgroundColor:
      (theme as any).components?.journeyStatus?.headerColour ?? theme.palette.grey[300],
    color:
      (theme as any).components?.journeyStatus?.headerTextColour ??
      theme.palette.getContrastText(
        (theme as any).components?.journeyStatus?.headerColour ?? theme.palette.grey[300],
      ),
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  '& tr': {
    backgroundColor:
      theme.components?.Table?.gridBackground || theme.palette.white.main,
  },
  '& tbody tr:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))

const TypeScriptTable: React.FC<TypeScriptTableProps> = ({
  data,
  columns,
  isLoading,
}) => {
  console.log('data', data)
  const [sorting, setSorting] = React.useState<SortingState>([])
  const [{ pageIndex, pageSize }, setPagination] =
    React.useState<PaginationState>({
      pageIndex: 0,
      pageSize: 10,
    })

  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize],
  )

  const table = useReactTable({
    data: data,
    columns,
    pageCount: Math.ceil(data?.size / pageSize) ?? -1,
    state: {
      sorting,
      pagination,
      //   columnVisibility,
    },
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    manualPagination: true,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  })

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <div className="p-2">
            <StyledTable>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {header.isPlaceholder ? null : (
                          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                          <div
                            {...{
                              className: header.column.getCanSort()
                                ? 'cursor-pointer select-none'
                                : '',
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                            {{
                              asc: (
                                <ArrowCircleUpSharpIcon
                                  sx={{
                                    marginBottom: '-5px',
                                  }}
                                />
                              ),
                              desc: (
                                <ArrowCircleDownSharpIcon
                                  sx={{
                                    marginBottom: '-5px',
                                  }}
                                />
                              ),
                            }[header.column.getIsSorted() as string] ?? null}
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{ textAlign: 'center' }}
                    >
                      Loading data...
                    </td>
                  </tr>
                ) : data === undefined || data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{ textAlign: 'center' }}
                    >
                      No data available.
                    </td>
                  </tr>
                ) : (
                  table.getRowModel().rows.map((row) => (
                    <tr
                      key={row.id}
                      onClick={() => {
                        console.log('row', row)
                      }}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                {table.getFooterGroups().map((footerGroup) => (
                  <tr key={footerGroup.id}>
                    {footerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.footer,
                              header.getContext(),
                            )}
                      </th>
                    ))}
                  </tr>
                ))}
              </tfoot>
            </StyledTable>
            <div className="h-2" />
          </div>
        </Grid>
        {/* <Grid item xs={12}>
          {console.log('Data size:', data)}
          <TablePagination
            component="div"
            count={data?.length ?? 0}
            page={pageIndex}
            onPageChange={(
              event: React.MouseEvent<HTMLButtonElement> | null,
              newPage: number,
            ) => {
              table.setPageIndex(newPage)
            }}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(e) =>
              table.setPageSize(Number(e.target.value))
            }
          />
        </Grid> */}
      </Grid>
    </Grid>
  )
}

export default TypeScriptTable
